import { enRbac } from '../en';
import { frRbac } from '../fr';
import { esRbac } from '../es';
import { deRbac } from '../de';

export const rbacModuleTranslations = {
  en: enRbac,
  fr: frRbac,
  es: esRbac,
  de: deRbac,
} as const;

